const hasBlock = (columnBlocks, blockType) => columnBlocks?.some(
  (block) => block.type === blockType,
);

export default hasBlock;
